import React, { useState } from 'react';
import { SxProps, TextField, Theme } from '@mui/material';

import { formatLengthToArchitecturalString, parseImperialLengthToInches } from '@paragon/client-tools';
import { notNullish } from '@paragon/utilities';

interface Props {
  label: string;
  sx?: SxProps<Theme>;
  placeholder?: string;

  tooltip?: string;
  fullWidth?: boolean;

  values: readonly number[];
  onChange(values: readonly number[]): void;
}

function lengthsToString(lengths: readonly number[]) {
  return lengths.map(formatLengthToArchitecturalString).join(', ');
}

export function LumberLengthsField(props: Props) {
  // TODO: handle props.value changing

  const [textValue, setTextValue] = useState(lengthsToString(props.values));

  function onChange(value: string): void {
    const numbers = value
      .split(',')
      .map(parseImperialLengthToInches)
      .filter(notNullish)
      .toSorted((a, b) => a - b);

    setTextValue(value);
    props.onChange(numbers);
  }

  function onBlur() {
    setTextValue(lengthsToString(props.values));
  }

  return (
    <TextField
      size="small"
      fullWidth={props.fullWidth}
      label={props.label}
      helperText={props.tooltip}
      sx={props.sx}
      placeholder={props.placeholder}
      value={textValue}
      onChange={(event) => onChange(event.target.value)}
      onFocus={(event) => event.target.select()}
      onBlur={onBlur}
    />
  );
}
